(function () {
    'use strict';

    angular
        .module('app')
        .controller('SubscriptionLogController', SubscriptionLogController);

    SubscriptionLogController.$inject = ['API','$scope',];

    function SubscriptionLogController(API, $scope) {
        var vm = this;
        vm.cancel = $scope.$parent.cancel;
        vm.resolve = $scope.$parent.resolve;
        vm.loadingState = {
            log: false,
        };

        vm.logRows = [];

        activate();

        function activate() {
            vm.subscriptionId = $scope.placeholders.subscriptionId;
            loadSubscriptionLog();
        }

        function loadSubscriptionLog() {
            vm.loadingState.log = true;
            var promise = API.SubscriptionLog.search({
                subscription_id: vm.subscriptionId,
                sort: '-created_at',
                'per-page': -1
            }).$promise;

            promise.then(function (response) {
                vm.logRows = response.items;
                vm.loadingState.log = false;
            }, function () {
            });
        }

    }
})();